export default __webpack_public_path__ + "static/media/36I-114292_-21041_0.1b77ef89.jpg";